import React from "react";

export default class Printable extends React.PureComponent {
  render() {
    return this.props.children;
  }
}
